/* tslint:disable */
/* eslint-disable */
/**
 * Plateformes API
 * API for managing plateformes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlateformeThemeDto } from './PlateformeThemeDto';
import {
    PlateformeThemeDtoFromJSON,
    PlateformeThemeDtoFromJSONTyped,
    PlateformeThemeDtoToJSON,
    PlateformeThemeDtoToJSONTyped,
} from './PlateformeThemeDto';

/**
 * 
 * @export
 * @interface CreatePlateformeCommand
 */
export interface CreatePlateformeCommand {
    /**
     * 
     * @type {string}
     * @memberof CreatePlateformeCommand
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlateformeCommand
     */
    code: string;
    /**
     * 
     * @type {PlateformeThemeDto}
     * @memberof CreatePlateformeCommand
     */
    theme?: PlateformeThemeDto;
}

/**
 * Check if a given object implements the CreatePlateformeCommand interface.
 */
export function instanceOfCreatePlateformeCommand(value: object): value is CreatePlateformeCommand {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function CreatePlateformeCommandFromJSON(json: any): CreatePlateformeCommand {
    return CreatePlateformeCommandFromJSONTyped(json, false);
}

export function CreatePlateformeCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePlateformeCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'code': json['code'],
        'theme': json['theme'] == null ? undefined : PlateformeThemeDtoFromJSON(json['theme']),
    };
}

export function CreatePlateformeCommandToJSON(json: any): CreatePlateformeCommand {
    return CreatePlateformeCommandToJSONTyped(json, false);
}

export function CreatePlateformeCommandToJSONTyped(value?: CreatePlateformeCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'code': value['code'],
        'theme': PlateformeThemeDtoToJSON(value['theme']),
    };
}

